import { Routes, Route } from "react-router-dom";
import LocationDetail from "./LocationDetail";

export default function LocationsRoutes() {
  return (
    <Routes>
      <Route path=":id" element={<LocationDetail />} />
    </Routes>
  );
}
